import React from "react";

import { DataType } from "@/jenesys-types/data/enums";
import { Client } from "@/jenesys-types/jenesys-entities/config";
import { NamedRoute } from "@/jenesys-types/routes/routes";

import { ManageClientsListRoute } from "@/components/routes/clients/ManageClientsListRoute";
import { ManageClientsRoute } from "@/components/routes/clients/ManageClientsRoute";
import { createCrudRoute } from "@/routes/crud";

// eslint-disable-next-line import/no-anonymous-default-export
export default (): NamedRoute => ({
  path: "clients",
  children: [
    createCrudRoute<Client>({
      path: "management",
      dataType: DataType.Clients,
      element: <ManageClientsRoute />,
      list: <ManageClientsListRoute />
    })
  ]
});
